module.exports = __webpack_public_path__ + "distribution/img/ok.ecc1579c.png";